export const getFeatureEligibility = ({ featureName, plans = [] }) => {
  if (plans.length === 0) return false
  const eligiblePlans = plans
    .flatMap(plan => plan.services_available)
    .filter(el => el.name === featureName && el.eligible === true)
  return eligiblePlans.length > 0
}

export default {
  getFeatureEligibility,
}
